

	
	
import apiCore from '../../utils/api-core';

export function getThreadByNumbers(botNumber, contactNumber) {
    return apiCore.get(`/api/v1/threads/${botNumber}/${contactNumber}`);
}

export function getThreadByNumbersWithDates(botNumber, contactNumber, start, end) {
    return apiCore.get(`/api/v1/threads/${botNumber}/${contactNumber}/${start}/${end}`);
}